export enum AppPermissions {
    cAPBasicUser = 'CAP_Basic_User',
    cAPFeatureAreasCanCreate = 'CAP-Feature_Areas-Can_Create',
    cAPFeatureAreasCanPublish = 'CAP-Feature_Areas-Can_Publish',
    cAPFeatureAreasCanUpdate = 'CAP-Feature_Areas-Can_Update',
    entAdminMetaDataCanAdmin = 'Ent_Admin_MetaDataCanAdmin',
    entAdminOtherCanAccess = 'Ent_Admin_OtherCanAccess',
    entAdminSecurityCanAccess = 'Ent_Admin_SecurityCanAccess',
    entAdminSecurityCanAdminAdvanced = 'Ent_Admin_SecurityCanAdminAdvanced',
    entAdminSecurityCanAdminUsers = 'Ent_Admin_SecurityCanAdminUsers',
    entAdminCanAccess = 'Ent_AdminCanAccess',
    entSecurityCanEmulate = 'Ent_Security_CanEmulate',
    entSecurityCanLogin = 'Ent_Security_CanLogin',
    entUiCanConfigure = 'Ent_Ui_CanConfigure',
    entUiContentCanEdit = 'Ent_Ui_Content_CanEdit',
    entWorkItemTrackingCanAccess = 'Ent_WorkItemTracking_CanAccess',
    entWorkItemTrackingCanAdmin = 'Ent_WorkItemTracking_CanAdmin',
    listAdmin = 'List_Admin',
    fitnessAdmin = 'Fitness_Admin',
    fitnessUserTypeLimitedMenusCanSeeAll = 'Fitness-User_Type_Limited_Menus-Can_See_All',
    challengeBasicAccess = 'Challenge-Basic_Access',
    challengeCanManage = 'Challenge-Can_Manage',
    activityCanLog = 'Activity-Can_Log',
    activityCanAdmin = 'Activity-Can_Admin',
    leaderboardCanView = 'Leaderboard-Can_View',
    teamCanManage = 'Team-Can_Manage',
}
